<template>
  <div class="page">
    <div style="width: 100%; display: flex; justify-content: center;">
      <TopBar></TopBar>
    </div>
    <div class="title">ID3 Decision Tree:</div>
    <div class="contents">
      <TreeChart v-if="ready" :graphData="graph.dot" :key="graph"></TreeChart>
     </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import TreeChart from "@/components/TreeChart";

import {buildTree} from "../api/tree"
import {ref} from "vue"


export default {
  name: "Tree",
  components: {
    TopBar,
    TreeChart,
  },

  setup() {

    let graph = ref({});
    let ready = ref(false);

    buildTree(graph, (val) => {
      ready.value = val;
    });

    return {
      graph: graph,
      ready: ready,
    }
  },
}
</script>

<style scoped>
.page {
  width: 900px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

}
.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}

.contents{
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>